import React, { Suspense } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Spinner from "../Spinner";

const PageAuthWrap = React.lazy(() => import("../../pages/PageAuth/PageAuthWrap"));
const NotFound = React.lazy(() => import("../../pages/NotFound"));
const MainPageWrap = React.lazy(() => import("../../pages/MainEscort/MainPageWrap"));

const Routes = ({ currentUser }) => {
  return (
    <Suspense fallback={<Spinner />}>
      <Switch>
        <Route exact path="/">
          <Redirect to="/signIn" />
        </Route>
        <Route exact path="/signIn">
          <PageAuthWrap />
        </Route>
        <Route exact path="/main">
          <MainPageWrap />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default Routes;
